import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <NFLTemplate {...props} team="New York Jets" teamShort="Jets" teamId={teamIds['New York Jets']} />
)
